import { Component, OnChanges, SimpleChanges, ChangeDetectionStrategy, input, output } from '@angular/core';
import {GuruEntity} from '../../../model/guru-entity';
import { FormsModule } from '@angular/forms';

import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-vertical-floor-a-cabinet-features-section',
    templateUrl: './vertical-floor-a-cabinet-features-section.component.html',
    styleUrls: ['./vertical-floor-a-cabinet-features-section.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIcon, FormsModule]
})
export class VerticalFloorACabinetFeaturesSectionComponent implements OnChanges {

  readonly selections = input.required<GuruEntity[]>();
  readonly invalidEntityNames = input.required<string[]>();
  readonly handArrangementImagePath = input<string>(undefined!);
  readonly pipeDetailImagePath = input<string>(undefined!);
  readonly selectionChanged = output<GuruEntity>();
  drainPanSelection!: GuruEntity;
  pipingControlsSelection!: GuruEntity;
  cabinetInsulationSelection!: GuruEntity;
  cabinetMaterialSelection!: GuruEntity;
  frontPanelInsulationSelection!: GuruEntity;
  rightExtensionSelection!: GuruEntity;
  extensionHeightSelection!: GuruEntity;
  outsideAirBoxSelection!: GuruEntity;
  insulatedRearExtensionSelection!: GuruEntity;
  tamperProofPanelSelection!: GuruEntity;
  trimKitSelection!: GuruEntity;
  levelingLegsSelection!: GuruEntity;
  leftExtensionSelection!: GuruEntity;
  extensionDepthSelection!: GuruEntity;
  collapsed: boolean = false;
  canExpand: boolean = true;
  private readonly selectionNames: string[] = ['USDrainPan', 'USSameSidePipeControls', 'USCabinetInsulation', 'USGSChassis', 'USRetBlkOff',
    'USCabExtRight', 'USCabExtHeight', 'USOutsideAir', 'USInsulatedAOR', 'USTamperProofPanel', 'USTrimKit', 'USLevelLegs', 'USCabExtLeft', 'USCabExtDepth'];

  constructor() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    const filteredSelections: GuruEntity[] = this.selections().filter(selection => this.selectionNames.indexOf(selection.Name) >= 0);
    if (filteredSelections.length === 0) {
      this.collapsed = true;
      this.canExpand = false;
    } else {
      this.drainPanSelection = this.getSelectionWithName(this.selectionNames[0], filteredSelections);
      this.pipingControlsSelection = this.getSelectionWithName(this.selectionNames[1], filteredSelections);
      this.cabinetInsulationSelection = this.getSelectionWithName(this.selectionNames[2], filteredSelections);
      this.cabinetMaterialSelection = this.getSelectionWithName(this.selectionNames[3], filteredSelections);
      this.frontPanelInsulationSelection = this.getSelectionWithName(this.selectionNames[4], filteredSelections);
      this.rightExtensionSelection = this.getSelectionWithName(this.selectionNames[5], filteredSelections);
      this.extensionHeightSelection = this.getSelectionWithName(this.selectionNames[6], filteredSelections);
      this.outsideAirBoxSelection = this.getSelectionWithName(this.selectionNames[7], filteredSelections);
      this.insulatedRearExtensionSelection = this.getSelectionWithName(this.selectionNames[8], filteredSelections);
      this.tamperProofPanelSelection = this.getSelectionWithName(this.selectionNames[9], filteredSelections);
      this.trimKitSelection = this.getSelectionWithName(this.selectionNames[10], filteredSelections);
      this.levelingLegsSelection = this.getSelectionWithName(this.selectionNames[11], filteredSelections);
      this.leftExtensionSelection = this.getSelectionWithName(this.selectionNames[12], filteredSelections);
      this.extensionDepthSelection = this.getSelectionWithName(this.selectionNames[13], filteredSelections);
    }
  }

  private getSelectionWithName(name: string, selections: GuruEntity[]): GuruEntity {
    for (const selection of selections) {
      if (selection.Name === name) {
        return JSON.parse(JSON.stringify(selection));
      }
    }
    return undefined!;
  }

  selectedValueChanged(selectionName: string, value: string): void {
    const entity: GuruEntity = new GuruEntity();
    entity.Name = selectionName;
    entity.Value = value;
    this.selectionChanged.emit(entity);
  }

  getExpansionIcon(): string {
    return this.collapsed ? 'arrow_drop_down' : 'arrow_drop_up';
  }

  toggleExpansion(): void {
    if (this.canExpand) {
      this.collapsed = !this.collapsed;
    }
  }

  isInvalidSelection(selectionName: string): boolean {
    return this.invalidEntityNames().indexOf(selectionName) >= 0;
  }

}
